(function () {
  'use strict';
  /*
    [VERIFY with Jaywant + Pranesh before spend]
    These plans need three NEW Shopify bundle variants (raw + pasteurized each),
    priced exactly ₹1,999 / ₹2,499 / ₹3,499. The 28 and 42 morning plans price
    below the store's current ₹95/litre, which needs Jaywant's written sign-off.
    Replace the VERIFY_* placeholders below with live variant ids.
  */
  var VARIANTS = {
    d42: { raw: 'VERIFY_VAR_42_RAW', pas: 'VERIFY_VAR_42_PAS', name: '42 Mornings', weeks: '6 Weeks', now: '₹3,499', mrp: '₹4,158', save: 'SAVE ₹659', per: '₹83', value: 3499 },
    d28: { raw: 'VERIFY_VAR_28_RAW', pas: 'VERIFY_VAR_28_PAS', name: '28 Mornings', weeks: '4 Weeks', now: '₹2,499', mrp: '₹2,772', save: 'SAVE ₹273', per: '₹89', value: 2499 },
    d21: { raw: 'VERIFY_VAR_21_RAW', pas: 'VERIFY_VAR_21_PAS', name: '21 Mornings', weeks: '3 Weeks', now: '₹1,999', mrp: '₹2,079', save: 'SAVE ₹80', per: '₹95', value: 1999 }
  };
  var plan = 'd42', milkType = 'raw';

  function byId(id) { return document.getElementById(id); }
  function track(name, data) { if (window.fbq) window.fbq('track', name, data || {}); }

  window.setPlan = function (p) { if (VARIANTS[p]) { plan = p; paint(); } };
  window.setType = function (t) { if (t === 'raw' || t === 'pas') { milkType = t; paint(); } };

  function paint() {
    var v = VARIANTS[plan];
    byId('pnow').textContent = v.now; byId('pmrp').textContent = v.mrp; byId('psave').textContent = v.save;
    byId('t-plan').textContent = v.name + ' · one bottle every dawn';
    byId('t-mrp').textContent = v.mrp; byId('t-now').textContent = v.now;
    byId('s-t').innerHTML = v.name + ' · ' + v.weeks + '<b>' + v.now + ' · ' + v.per + ' a morning</b>';
    document.querySelectorAll('.pcard').forEach(function (el) { el.classList.toggle('on', el.dataset.plan === plan); });
    document.querySelectorAll('.mtype').forEach(function (el) { el.classList.toggle('on', el.dataset.mt === milkType); });
  }
  paint();

  // Gallery.
  var mainImage = byId('gmain');
  document.querySelectorAll('#gthumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) { mainImage.src = thumb.src; mainImage.alt = thumb.alt; }
      document.querySelectorAll('#gthumbs img').forEach(function (x) { x.classList.remove('on'); });
      thumb.classList.add('on');
    });
  });

  // Add to cart through Shopify Ajax API so the GoKwik cart embed can observe the cart.
  // Populate the six live Shopify variant IDs below before launch.
  window.buy = function (btn) {
    var v = VARIANTS[plan];
    var id = v[milkType];
    if (!id || String(id).indexOf('VERIFY') === 0 || String(id).indexOf('REPLACE') === 0) {
      var err = byId('atcerr');
      if (err) {
        err.style.display = 'block';
        err.textContent = 'This plan is not connected to a Shopify variant yet. Please contact the store team.';
      }
      return;
    }
    track('AddToCart', { content_name: 'A2 Desi Cow Milk ' + v.name, content_ids: [String(id)], content_type: 'product', value: v.value, currency: 'INR' });
    if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(id), quantity:1}]})
    }).then(function (res) {
      return res.json().catch(function(){return {};}).then(function(data){
        if (!res.ok) throw new Error(data.description || data.message || 'Unable to add this plan.');
        return data;
      });
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
      var err = byId('atcerr');
      if (err) {
        err.style.display = 'block';
        err.textContent = 'Added to cart. If the GoKwik drawer did not open automatically, open the cart drawer to continue.';
      }
    }).catch(function (error) {
      var err = byId('atcerr');
      if (err) { err.style.display = 'block'; err.textContent = error.message || 'Unable to add this plan.'; }
    }).finally(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
    });
  };

  // Countdown to tonight's 9 PM cutoff; rolls to the next day after 9 PM.
  var cd = byId('cd');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = new Date();
    var t = new Date(now); t.setHours(21, 0, 0, 0);
    if (now >= t) t.setDate(t.getDate() + 1);
    var s = Math.floor((t - now) / 1000);
    cd.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
  }
  tick(); setInterval(tick, 1000);

  // Sticky bar after one viewport of scroll.
  var sticky = byId('sticky');
  function onScroll() {
    if (window.scrollY > window.innerHeight) sticky.classList.add('on');
    else sticky.classList.remove('on');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  track('ViewContent', { content_name: 'A2 Desi Cow Milk Glass Bottle', currency: 'INR' });
})();

/* Meta Pixel initialization from source funnel */
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init','575630972822396');fbq('track','PageView');
